import { useQuery } from '@tanstack/react-query';
import { httpClient } from '../../services/http.client';
import { queryKeys } from '../../lib/query-keys';

export function useBids(orgId: string | null) {
  return useQuery({
    queryKey: queryKeys.bids.all(orgId ?? ''),
    queryFn: () => httpClient.get(`/api/v1/bids?organization_id=${orgId}`),
    enabled: !!orgId,
    staleTime: 30_000,
    select: (res: any) => {
      const raw = res?.data ?? res;
      return Array.isArray(raw) ? raw : (raw?.data ?? []);
    },
  });
}
